import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { Dashboard } from './pages/Dashboard';
import { TeamsPage } from './pages/TeamsPage';
import { LeadUploadPage } from './pages/LeadUploadPage';
import { HistoryPage } from './pages/HistoryPage';
export function App() {
  const [activePage, setActivePage] = useState('dashboard');
  const renderPage = () => {
    switch (activePage) {
      case 'dashboard':
        return <Dashboard onNavigate={setActivePage} data-id="element-0" />;
      case 'teams':
        return <TeamsPage data-id="element-1" />;
      case 'upload':
        return <LeadUploadPage data-id="element-2" />;
      case 'history':
        return <HistoryPage data-id="element-3" />;
      default:
        return <Dashboard onNavigate={setActivePage} data-id="element-4" />;
    }
  };
  return <div className="flex h-screen bg-[#f8f9fb] overflow-hidden font-sans text-gray-900" data-id="element-5">
      <Sidebar activePage={activePage} onNavigate={setActivePage} data-id="element-6" />

      <main className="flex-1 overflow-y-auto" data-id="element-7">{renderPage()}</main>
    </div>;
}